import { MyDealDTO } from '@/openapi';
import styles from './MyDealCard.module.css';
import { ReactComponent as ReportSVG } from '@Assets/svg/report.svg';
import { useTranslation } from 'react-i18next';

interface MyDealCardProps {
	data: MyDealDTO;
	headerColor?: string;
}

const MyDealCard = ({ data, headerColor = '#ea5b0c' }: MyDealCardProps) => {
	const { t } = useTranslation();

	// Mappa delle percentuali per stato
	const statusProgressMap: Record<string, number> = {
		OFFERTA_DA_FARE: 0,
		NO_RISPOSTA: 0,
		CONTATTO_AVVENUTO: 10,
		OFFERTA_FATTA: 20,
		IN_SOSPESO: 20,
		OFFERTA_RIMANDATA: 30,
		ATTESA_DOCUMENTI: 40,
		TRATTATIVA: 60,
		CHIUSA_VINTA: 80,
		PRATICA_RESPINTA: 100,
		CHIUSA_PERSA: 100,
		AUTO_CONSEGNATA: 100,
		CONTRATTI_SCADUTI: 100
	};

	const getStatusMessage = () => {
		if (!data.dealStatus) return '';

		const translationKey = `profile.myDeals.dealStatus.${data.dealStatus}`;

		if (data.dealStatus === 'AUTO_CONSEGNATA') {
			return t(translationKey as any, {
				carBrand: data.carBrand || 'N/A',
				carModel: data.carModel || 'N/A'
			});
		}

		return t(translationKey as any);
	};

	const getProgressPercentage = () => {
		return data.dealStatus ? statusProgressMap[data.dealStatus] || 0 : 0;
	};

	return (
		<div className={styles.myDealCard}>
			<div className={styles.myDealCardHeader} style={{ backgroundColor: headerColor }}>
				<h3>{data.leadEmail}</h3>
				<ReportSVG className={styles.dealIcon} />
			</div>
			<div className={styles.myDealCardBody}>
				<p>{getStatusMessage()}</p>
			</div>
			<div className={styles.myDealCardFooter}>
				<div className={styles.progressInfo}>
					<span className={styles.progressLabel}>{t('profile.myDeals.progress')}</span>
					<span className={styles.progressPercentage}>{getProgressPercentage()}%</span>
				</div>
				<div className={styles.progressBar}>
					<div className={styles.progressFill} style={{ width: `${getProgressPercentage()}%` }} />
				</div>
			</div>
		</div>
	);
};
export default MyDealCard;
